import * as React from 'react';

export type useScrollToTopProps = () => void;

export const useScrollToTop: useScrollToTopProps = () => {
  React.useLayoutEffect(() => window.scrollTo(0, 0), []);
};
